<template>
    <transition name="fade">
        <div v-if="ready" class="PrivateContractForReportWidget__Component">
            <div v-for="contract in contracts" :key="contract.Id" class="PrivateContractForReportWidget__Component__Item">
                <label>
                    שוכר:
                    <a :href="`/clients/${contract.Profile.Id}`"><span>{{contract.Profile.Name}}</span></a>
                </label>
                <label>
                    ח.פ:
                    <span>{{contract.Profile.IdNumber}}</span>
                </label>
                <label v-if="contract.ContractOwner">
                    חברת ליסינג:
                    <a :href="`/clients/${contract.ContractOwner.Id}`"><span>{{contract.ContractOwner.Name}}</span></a>
                </label>
                <label>
                    מתאריך:
                    <FieldDateHourInline :value="contract.StartDate" />
                </label>
                <label>
                    עד תאריך:
                    <FieldDateHourInline :value="contract.EndDate" />
                </label>
                <label>
                   הצהרת חוכר:
                    <span>{{contract.HasTransferHtml ? 'כן' : 'לא'}}</span>
                </label>
                <label>
                    קיים טופס איסוף השכרה:
                    <span>{{contract.HasRentalPickUpFormHtml ? 'כן' : 'לא'}}</span>
                </label>
                <label>
                    קיים טופס החזרת השכרה:
                    <span>{{contract.HasRentalReturnFormHtml ? 'כן' : 'לא'}}</span>
                </label>
                <label>
                    קיים רישיון נהיגה:
                    <span>{{contract.HasDriversLicenseHtml ? 'כן' : 'לא'}}</span>
                </label>
                <label>
                    תאריך עדכון:
                    <FieldDateHourInline :value="contract.UpdateDate" />
                </label>
                <label>
                        עודכן ע"י:
                    <span> {{ contract.UpdatingUserName ? contract.UpdatingUserName : '-' }} </span>
                </label>
            </div>
            <div v-if="!contracts.length">לא קיים חוזה פרטי</div>
        </div>
    </transition>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import ReportService from '@/services/ReportService';
import FieldDateHourInline from '../Fields/FieldDateHourInline.vue';

export default {
    name: 'PrivateContractForReportWidget',
    props: ['ready', 'namespace'],
    data() {
        return {
            contracts: [],
        };
    },
    beforeCreate() {
        const { namespace } = this.$options.propsData;
        const { mapState } = createNamespacedHelpers(namespace);
        this.$options.computed = {
            ...mapState(['Id']),
        };
    },
    methods: {
        init() {
            if (this.Id) {
                ReportService.getPrivateVehicleContracts(this.Id)
                .then((r) => {
                    this.contracts = r.data || [];
                });
            }
            this.$emit('onReady', true);
        },
    },
    watch: {
        // immediate so the fetch still runs when the widget is mounted late (it is hidden until the
        // parent resolves whether a private contract exists, by which point `ready` is already true).
        ready: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.init();
                }
            },
        },
    },
    components: {
        FieldDateHourInline,
    },
};
</script>

<style lang="scss" scoped>
    .PrivateContractForReportWidget__Component {
        width: 100%;

        .PrivateContractForReportWidget__Component__Item {
            border: 1px solid #e4eaf1;
            background-color: #eef1f3;
            border-radius: 3px;
            margin: 10px 0;
            padding: 10px;
            position: relative;
            display: flex;
            flex-direction: column;
            font-weight: bold;

            span {
                font-weight: normal;
            }
            a {
                color: #06c;
                cursor: pointer;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
</style>
